import { Loader } from "lucide-react";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { FormFieldset, Input } from "../../../../../components/Form";
import CustomDropdown from "../../../../../components/DropDown";
import { CancelButton, FormButton } from "../../../../../components/Button";
import { IContact } from "../../Contact.props";
import useContact from "./useContact";
import { useNavigate } from "react-router-dom";

const AddContact: React.FC = () => {
  const navigate = useNavigate();
  const {
    handleSubmit: submitContact,
    loading,
    interest,
    interestId,
    services,
    serviceId,
    outputStatuses,
    outputStatusId,
    platforms,
    platformId,
    contactData,
    setInterestId,
    setServiceId,
    setOutputStatusId,
    setPlatformId,
    fetchInterestsData,
    fetchServicesData,
    fetchOutputStatusesData,
    fetchPlatformsData,
  } = useContact();

  useEffect(() => {
    fetchInterestsData();
    fetchServicesData();
    fetchOutputStatusesData();
    fetchPlatformsData();
  }, []);

  // form setup
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<IContact>();

  const personalFields = [
    { label: "Client Name", name: "name", type: "text", required: true },
    { label: "Company Name", name: "companyName", type: "text" },
    { label: "Email", name: "email", type: "email" },
    { label: "Phone", name: "phone", type: "tel" },
    { label: "Description", name: "description", type: "text" },
    { label: "LinkedIn", name: "linkedin", type: "text" },
    { label: "Timezone", name: "timezone", type: "text" },
  ] as const;

  // const nestedFields = [
  //   { label: "Currency", name: "billingInfo.currency", type: "text" },
  //   { label: "Contract Type", name: "contractDetails.con  tractType", type: "text" },
  // ] as const;

  const handleCancel = () => navigate("/contact");

  console.log("contact ", contactData);
  
  return (
    <div className="flex flex-col items-center w-full h-full pr-8 pl-6 ">
      <div className="bg-white shadow-md rounded-lg pt-6 pb-6 w-full ">
        <div className="border-b-2 w-[100%]">
          <h1 className="text-3xl mb-2 text-fontBlack ml-5">Add Client</h1>
        </div>
        {loading && <Loader />}
        <form
          onSubmit={handleSubmit(submitContact)}
          className="space-y-6 p-6 h-[75vh] overflow-y-scroll"
          autoComplete="off"
        >
          <FormFieldset Ftitle="Personal details">
            <div className="grid grid-cols-5 m-4 gap-4 justify-between  ">
              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Status <span className="text-red-500">*</span>
                </label>
                <select
                  {...register("status", { required: "Status is required" })}
                  className="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor w-full px-3"
                >
                  <option value="">Select Status</option>
                  <option value="Active">Active</option>
                  <option value="InActive">InActive</option>
                </select>
                {errors.status && <p className="text-red-500 text-sm">{errors.status.message}</p>}
              </div>

              <CustomDropdown
                label="Interest"
                options={interest}
                defaultOptionId={interestId}
                setDefaultOptionId={setInterestId}
                displayProperty="name"
                value={interestId}
                style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor w-full mb-4"
              />

              <CustomDropdown
                label="Services"
                options={services}
                defaultOptionId={serviceId}
                setDefaultOptionId={setServiceId}
                displayProperty="name"
                value={serviceId}
                style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor w-full mb-4"
              />

              <CustomDropdown
                label="Output Status"
                options={outputStatuses}
                defaultOptionId={outputStatusId}
                setDefaultOptionId={setOutputStatusId}
                displayProperty="name"
                value={outputStatusId}
                style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor w-full mb-4"
              />

              <CustomDropdown
                label="Platforms"
                options={platforms}
                defaultOptionId={platformId}
                setDefaultOptionId={setPlatformId}
                displayProperty="name"
                value={platformId}
                style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor w-full mb-4"
              />
            </div>

            {/* personal inputs */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 m-4">
              {personalFields.map((field) => (
                <div key={field.name}>
                  <Input
                    {...register(field.name as any, {
                      required: (field as { required?: boolean }).required ? `${field.label} is required` : false,
                    })}
                    name={field.name}
                    label={field.label}
                    type={field.type}
                  />
                  {errors[field.name as keyof IContact] && (
                    <p className="text-red-500 text-sm">
                      {(errors[field.name as keyof IContact] as any).message}
                    </p>
                  )}
                  
                </div>
              ))}
            </div>

            {/* nested inputs */}
            {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6 m-4">
              {nestedFields.map((field) => (
                <Input
                  key={field.name}
                  {...register(field.name as any)}
                  name={field.name}
                  label={field.label}
                  type={field.type}
                />
              ))}
            </div> */}
          </FormFieldset>

          {/* action buttons */}
          <div className="flex justify-center mt-6 ml-2 gap-3">
            <CancelButton
              className="py-2 px-4 h-[56px] w-[200.5px]"
              onClick={handleCancel}
              type="button"
            >
              Cancel
            </CancelButton>
            <FormButton className="py-2 px-4 h-[56px] w-[200.5px]" type="submit">
              ADD
            </FormButton>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddContact;
